module.exports = __webpack_public_path__ + "img/apnic.6df07f49.svg";